<template>
  <div id="PrivacyPolicy" class="container-fluid px-0 privacy-policy">
    <header class="page-header">
      <div class="d-flex flex-column align-items-center">
        <img src="/img/spectrum_life_logo_light.png" class="logo" alt="logo">
        <h2 class="mb-0 header"> Privacy Policy </h2>
      </div>
    </header>
    <main class="content">
      <div class="content-card">
        <PrivacyPolicyContent />
      </div>
    </main>
    <footer>
      <Footer v-if="$store.state.user.authenticated"></Footer>
    </footer>
  </div>
</template>

<script>
import TopNav from "@/components/TopNav.vue";
import MobileNav from "@/components/MobileNav.vue";
import Footer from "../components/Footer";
import PrivacyPolicyContent from "../components/PrivacyPolicyContent.vue";

export default {
  name: "PrivacyPolicyVPC",
  components: {
    PrivacyPolicyContent,
    Footer,
    TopNav,
    MobileNav
  },
};
</script>
<style lang="less">
#PrivacyPolicy {
  background-color: #fbfafa;
  
  .page-header {
    padding: 60px 20px 20px;
    color: #122130;
  }
  
  td {
    border: 1px solid black !important;
    padding: 3px;
  }
  
  strong {
    font-family: "DMSans Bold", sans-serif;
  }
  
  font-size: 1.6rem;
  font-family: "DMSans", sans-serif;
  
  label {
    margin-bottom: 0;
  }
  
  .logo {
    max-width: 350px;
    width: 100%;
    padding-bottom: 50px;
  }
  
  .header {
    text-align: center;
    font-size: 3.8rem;
    letter-spacing: normal;
    color: #122130;
  }
  
  .content {
    padding: 20px 20px 60px;
  }
  
  .content-card {
    height: 100%;
    background: #ffffff;
    max-width: 1000px;
    padding: 40px 60px 30px;
    margin: 0 auto;
    border-radius: 16px;
    overflow-x: scroll;
    color: #122130;
    p, li {
      color: #122130
    }
    @media only screen and  (max-width: 500px) {
      padding: 20px;
      ul {
        padding-inline-start: 20px;
      }
    }
  }
  
}
</style>
